export default [
    {
        path: '/old/chldMain/:scrnDiv',
        name: 'chldMain',
        component: () => import('@/views/old/chld/chldMain.vue'),
        props: true
    },
    {
        path: '/old/main',
        name: 'main',
        component: () => import('@/views/main.vue')
        
    },
    {
        path: '/old/safeMain',
        name: 'safeMain',
        redirect: '/old/chldMain/safe'
    },
    // 성장지수_메인
    {
        path: '/old/gidxMain',
        name: 'gidxMain',
        redirect: '/old/chldMain/gidx'
    },
    // 성장지수_영양섭취가이드1
    {  
        path: '/old/chldMain/gidx/gidxNutrEatGuid01/:gfixDt/:stndDt',
        name: 'gidxNutrEatGuid01',
        component: () => import('@/views/old/chld/gidx/gidxNutrEatGuid01.vue'),
        props: true
    },
    // 성장지수_영양섭취가이드2
    {  
        path: '/old/chldMain/gidx/gidxNutrEatGuid02/:stndDt/:nutrCd',
        name: 'gidxNutrEatGuid02',
        component: () => import('@/views/old/chld/gidx/gidxNutrEatGuid02.vue'),
        props: true
    },
    // 성장지수_신체활동가이드
    {  
        path: '/old/chldMain/gidx/gidxPhysActGuid/:gfixDt',
        name: 'gidxPhysActGuid',
        component: () => import('@/views/old/chld/gidx/gidxPhysActGuid.vue'),
        props: true
    },
    // 성장지수_영양소별_식품목록
    {  
        path: '/old/chldMain/gidx/gidxNutrFoodList/:nutrCd',
        name: 'gidxNutrFoodList',
        component: () => import('@/views/old/chld/gidx/gidxNutrFoodList.vue'),
        props: true
    },
    {
        path: '/old/fidxMain',
        name: 'fidxMain',
        redirect: '/old/chldMain/fidx'
    },
    //비만예측 조사1
    {  
        path: '/old/fprdtQustInsp01',
        name: 'fprdtQustInsp01',
        component: () => import('@/views/old/chld/fidx/fprdtQustInsp01.vue')
    },
    //비만예측 조사2
    {  
        path: '/old/fprdtQustInsp02',
        name: 'fprdtQustInsp02',
        component: () => import('@/views/old/chld/fidx/fprdtQustInsp02.vue')
    },
    //비만지수추이
    {
        path: '/old/fidxTrnd',
        name: 'fidxTrnd',
        component: () => import('@/views/old/chld/fidx/fidxTrnd.vue')
    },
    //영양섭취가이드1
    {  
        path: '/old/fidxNutrEatGuid01/:stdtNo/:gfixDt',
        name: 'fidxNutrEatGuid01',
        component: () => import('@/views/old/chld/fidx/fidxNutrEatGuid01.vue'),
        props: true
    },
    //영양섭취가이드2
    {
        path: '/old/fidxNutrEatGuid02/:stdtNo/:gfixDt/:nutrCd/:nutrNm',
        name: 'fidxNutrEatGuid02',
        component: () => import('@/views/old/chld/fidx/fidxNutrEatGuid02.vue'),
        props: true
    },
    //영양소별 식품목록
    {
        path: '/old/fidxNutrFoodList/:nutrCd/:nutrNm',
        name: 'fidxNutrFoodList',
        component: () => import('@/views/old/chld/fidx/fidxNutrFoodList.vue'),
        props: true
    },
    //신체활동가이드(비만)
    {
        path: '/old/fidxPhysActGuid',
        name: 'fidxPhysActGuid',
        component: () => import('@/views/old/chld/fidx/fidxPhysActGuid.vue')
    },
    {
        path: '/old/bifoMain',
        name: 'bifoMain',
        redirect: '/old/chldMain/bifo'
    },
    {
        path: '/old/strsMain',
        name: 'strsMain',
        redirect: '/old/chldMain/strs'
    },
    {
        path: '/old/cbeeMain',
        name: 'cbeeMain',
        redirect: '/old/chldMain/cbee'
    },

    {
        path: '/old/locMain',
        name: 'locMain',
        component: () => import('@/views/old/chld/safe/locMain.vue')
    },

    {
        path: '/old/zoneDetl',
        name: 'zoneDetl',
        component: () => import('@/views/old/chld/safe/zoneDetl.vue'),
        props: true
    },

    // 신체지수 
    {
        path: '/old/bifoSubMain',
        name: 'bifoSubMain',
        component: () => import('@/views/old/chld/bifo/bifoSubMain.vue')        
    },

    // 운동기록
    {
        path: '/old/excsList',
        name: 'excsList',
        component: () => import('@/views/old/chld/bifo/excsList.vue')
    },
    // 건강/활동량
    {
        path: '/old/eatStat',
        name: 'eatStat',
        component: () => import('@/views/old/chld/bifo/eatStat.vue')
    },

    // 식단등록
    {
        path: '/old/eatRegi/:etimDivNm',
        name: 'eatRegi',
        component: () => import('@/views/old/chld/bifo/eatRegi.vue'),
        props: true
    },

    // 식단표조회
    {
        path: '/old/fmenuList',
        name: 'fmenuList',
        component: () => import('@/views/old/chld/bifo/fmenuList.vue')
    },
     // 식단표등록
     {
        path: '/old/fmenuRegi',
        name: 'fmenuRegi',
        component: () => import('@/views/old/chld/bifo/fmenuRegi.vue')
    },
    // QnA목록
    {
        path: '/old/qnaList/:ansDiv',
        name: 'qnaList',
        component: () => import('@/views/old/etc/qna/qnaList.vue'),
        props: true
    },
    // QnA등록
    {
        path: '/old/qnaRegi/:qnaNo/:ansDiv',
        name: 'qnaRegi',
        component: () => import('@/views/old/etc/qna/qnaRegi.vue'),
        props: true
    },
    // QnA상세
    {
        path: '/old/qnaDetl/:qnaNo/:ansDiv',
        name: 'qnaDetl',
        component: () => import('@/views/old/etc/qna/qnaDetl.vue'),
        props: true
    },
    
]
